module.exports = __webpack_public_path__ + "img/506.f702c781.jpg";